import type { ReservationRequestStatus } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import { RESERVATION_REQUEST_LIST_BY_UPDATED_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_REQUEST_QUERY } from "../schema";

type Props = {
	queryVariables?: {
		hotelID: string;
		from: string;
		to: string;
		reservationRequestStatus: ReservationRequestStatus;
	};
};

export const useReservationRequestListByUpdatedDateQuery = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		RESERVATION_REQUEST_LIST_BY_UPDATED_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_REQUEST_QUERY,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);

	const { onConvertQueryData } = Converter.useReservationListByUpdatedDateQueryData();
	const { queryData } = onConvertQueryData({ serverData: data });

	return {
		queryData,
	};
};
